// extracted by mini-css-extract-plugin
export default {"Container":"Checkbox_Container__-4S5V"};